<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<vx-tooltip text="Modifier l'URL LinkedIn" placement="top">
			<span class="cursor-pointer" @click="handleClick">
				<feather-icon
					icon="EditIcon"
					class="m-0"
					style="color: #0a66c2"
				/>
			</span>
		</vx-tooltip>
	</div>
</template>

<script>
import Vue from "vue";
import EditLinkedinUrlPopup from "../EditLinkedinUrlPopup.vue";

export default {
	name: "EditLinkedinRenderer",
	data() {
		return {
			onePs: {},
		};
	},
	created() {
		this.onePs = this.params.data;
	},
	methods: {
		handleClick() {
			let ComponentClass = Vue.extend(EditLinkedinUrlPopup);
			let popup = new ComponentClass({
				propsData: {
					popupActive: true,
					prospectId: this.onePs.id,
					currentUrl: this.onePs.linkedin_url || "",
				},
			});
			popup.$mount();
			document.body.appendChild(popup.$el);

			// Reflect the new URL in the grid without a full reload
			popup.$on("updated", (newUrl) => {
				this.onePs.linkedin_url = newUrl;
				if(this.params.api) {
					this.params.api.refreshCells({
						rowNodes: [this.params.node],
						force: true,
					});
				}
			});

			// Clean up the detached element once the popup closes
			const cleanup = () => {
				this.$nextTick(() => {
					if(popup.$el && popup.$el.parentNode) {
						popup.$el.parentNode.removeChild(popup.$el);
					}
					popup.$destroy();
				});
			};
			popup.$on("close", cleanup);
			popup.$on("updated", cleanup);
		},
	},
};
</script>
